var d = Object.defineProperty;
var h = (i, n, e) => n in i ? d(i, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[n] = e;
var r = (i, n, e) => (h(i, typeof n != "symbol" ? n + "" : n, e), e);
class l {
  constructor() {
    this.eventListener = {};
  }
  addEventListener(n, e) {
    return this.eventListener[n] = this.eventListener[n] || [], this.eventListener[n].push(e), this;
  }
  removeEventListener(n, e) {
    const t = this.eventListener[n];
    if (t) {
      let s;
      for (; (s = t.indexOf(e)) !== -1; )
        t.splice(s, 1);
    }
  }
  trigger(n, e) {
    (this.eventListener[n] || []).forEach((t) => {
      t(e);
    });
  }
}
const v = "v14";
class c extends l {
  constructor() {
    super(...arguments);
    r(this, "_handle");
    r(this, "_handleSetCallbacks", []);
  }
  _setHandle(e) {
    this._handle = e, this._handleSetCallbacks.forEach((t) => t(e)), this._handleSetCallbacks = [], Object.entries(this.eventListener).forEach(([t, s]) => {
      e.addEventListener(t, s);
    }), this.eventListener = {};
  }
  addEventListener(e, t) {
    return this._handle ? (this._handle.addEventListener(e, t), this) : super.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    if (this._handle)
      return this._handle.removeEventListener(e, t), this;
    super.removeEventListener(e, t);
  }
  async tearDown() {
    var e;
    if (this._handle)
      await ((e = this._handle) == null ? void 0 : e.tearDown());
    else
      return this._handleSetCallbacks.push(() => {
        this.tearDown();
      }), Promise.resolve();
  }
  get version() {
    var e;
    return (e = this._handle) == null ? void 0 : e.version;
  }
}
const a = (i) => `v${(i || v).replace(/^v/, "")}`, o = {
  init(i) {
    const n = new c();
    return import(/* webpackIgnore: true */ /* @vite-ignore */ i.sdkUrl || `https://sdk.onfido.com/${a(i.version)}/Onfido.js`).then((t) => {
      const { Onfido: s } = t;
      n._setHandle(s.init(i));
    }).catch((t) => {
      var s;
      n.trigger("error", { error: t }), (s = i.onError) == null || s.call(i, t);
    }), n;
  }
};
Object.defineProperty(o, "environment", {
  get: () => window == null ? void 0 : window.Onfido.environment,
  set: (i) => {
    window.Onfido = window.Onfido || {}, window.Onfido.environment = i;
  }
});
const L = o;
export {
  L as Onfido,
  a as prefixVersion
};
